import IconsEnum from "../../classes/enums/IconsEnum";
import IconButton from "../iconButton/IconButton";
import { TooltipOrientation } from "../tooltip/Tooltip";
import { useKeyboardActivation } from "../../hooks/useKeyboardActivation";
import "./CloseButton.css";

const CloseButton = ({
  onClose,
  tooltip = "Close",
  disabled = false,
  className = "",
}) => {
  const closeKeyDownHandler = useKeyboardActivation(onClose);

  return (
    <div
      role="button"
      tabIndex={0}
      onKeyDown={closeKeyDownHandler}
      className={`close-button-container ${className}`}
    >
      <IconButton
        icon={IconsEnum.CLOSE}
        onClick={onClose}
        noBgColor={true}
        className="close-button"
        disabled={disabled}
        title={tooltip}
        tooltipOrientation={TooltipOrientation.Bottom}
      />
    </div>
  );
};

export default CloseButton;

